export type NoResultsProps = {
    label: string;
  };

export { default as NoResults } from './NoResults';
